import React, { useState, useContext } from "react";
import Application from "../../../StateContext/Application";

const RefundFiles = (props) => {
  const statecalls = useContext(Application);
  const { GetRefundFiles } = statecalls;
  const [refundfiles, setRefundFiles] = useState([]);
  const [refunddata,setRefundData]= useState({});


  async function AllRefundFiles(e) {
    e.preventDefault()
    try {
        let data = await GetRefundFiles(refunddata.para);
    console.log(refunddata.para);
    setRefundFiles(data);
    } catch (error) {
        console.error(error)
    }
  }

  return (
    <>
    <div style={{backgroundColor:"#f6f8fc",padding:"50px"}}>
            <div style={{ display: "grid" ,border:"2px solid red",borderRadius:"20px",border:"none",padding:"20px",backgroundColor:'white'}}>
                <div style={{ display: 'grid' }}>
                    <div>
                        <label className='heading'>Search Refund Files</label>
                        <form onSubmit={AllRefundFiles} style={{width:'70vw'}} className='my-3'>
                            <input className='mb-3 form-control ' style={{ display: "flex", justifyContent: "center" }} type='search' id="para" placeholder='Enter Tender ID/Tender Name' onChange={(e)=>setRefundData({...refunddata,[e.currentTarget.id]:e.target.value})}/>
                            <button className="btn btn-primary" style={{backgroundColor:"#e73d26",border:"none"}}>Search</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
      <div style={{ padding: "50px", overflow: "auto" }}>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sr.no.</th>
              <th>Tender ID</th>
              <th>Tender Name</th>
              <th>File Name</th>
              <th>Upload Date</th>
              <th>Refund Processed by</th>
            </tr>
          </thead>
          <tbody>
            {
            refundfiles && refundfiles.map((e,index) => {
                return (
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{e.Tender_ID}</td>
                    <td>{e.Tender_Name}</td>
                    <td>{e.FileName}</td>
                    <td>{e.Upload_Date}</td>
                    <td>{e.Refund_Processed_by}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RefundFiles;
